import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeTitle',
  standalone: true,
})
export class CapitalizeTitlePipe implements PipeTransform {
  transform(value: unknown): string {
    if (typeof value !== 'string') {
      return '';
    }
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return '';
    }
    const words = trimmed.split(/\s+/);
    if (this.isEntirelyUppercase(trimmed)) {
      if (words.length === 1 && this.isShortAcronym(words[0])) {
        return trimmed;
      }
      return words.map((word) => this.titleCaseSegments(word)).join(' ');
    }
    return words.map((word) => this.capitalizeWord(word)).join(' ');
  }

  private capitalizeWord(word: string): string {
    if (this.hasInternalCapital(word) || this.isShortAcronym(word)) {
      return word;
    }
    if (word === word.toLocaleLowerCase() && word.length <= 3) {
      return word;
    }
    return this.titleCaseSegments(word);
  }

  private titleCaseSegments(word: string): string {
    const apostrophe = word.includes('\u2019') ? '\u2019' : "'";
    if (word.includes("'") || word.includes('\u2019')) {
      return word
        .split(/['\u2019]/)
        .map((segment) => this.titleCasePlain(segment))
        .join(apostrophe);
    }
    return this.titleCasePlain(word);
  }

  private titleCasePlain(segment: string): string {
    if (segment.length === 0) {
      return segment;
    }
    const first = segment.charAt(0).toLocaleUpperCase();
    const rest = segment.slice(1).toLocaleLowerCase();
    return `${first}${rest}`;
  }

  private hasInternalCapital(word: string): boolean {
    const rest = word.slice(1);
    return rest !== rest.toLocaleLowerCase();
  }

  private isEntirelyUppercase(value: string): boolean {
    const letters = value.replace(/[^A-Za-z]/g, '');
    return letters.length > 0 && value === value.toLocaleUpperCase();
  }

  private isShortAcronym(word: string): boolean {
    const letters = word.replace(/[^A-Za-z]/g, '');
    return (
      letters.length >= 2 &&
      letters.length <= 5 &&
      word === word.toLocaleUpperCase()
    );
  }
}
